import type { IReportsApiPort } from '@reports/application/ports';
import type { BlockDataRequestDto, ChartBlockViewDto } from '@reports/application/dtos';
import { mapChartBlockDataToViewDto } from '@reports/application/mappers';

export const fetchChartBlockDataUseCase = (apiPort: IReportsApiPort) => {
  const execute = async (filters: BlockDataRequestDto, endpoint: string): Promise<ChartBlockViewDto> => {
    const chartBlockData = await apiPort.fetchChartBlock(filters, endpoint);

    const chartBlockViewDto = mapChartBlockDataToViewDto(chartBlockData);

    return chartBlockViewDto;
  };

  return { execute };
};
